import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { EnumUpdateRemaindStatus } from "../../../../server/routes/logUpdated/price/types";
import { EnumMarketplace } from "../../../../server/routes/marketplace/types";
import Article from "../../components/Article";
import LogItem from "./LogItem";
import LogPagination from "./LogPagination";
import PageFilter from "./PageFilter";
import useList from "./Provider/hooks/useList";
import usePagination from "./Provider/hooks/usePagination";
import { PageArticleFC } from "./types";

const PageArticle: PageArticleFC = () => {
  const { items, isLoading } = useList();
  const { perPage } = usePagination();
  return (
    <Article>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PageFilter />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {isLoading ? (
              Array.from(Array(perPage).keys()).map((i, index) => (
                <Grid item xs={12} key={index}>
                  <LogItem
                    id={0}
                    dateTime={new Date()}
                    marketplace={{
                      uid: "",
                      type: EnumMarketplace.OZON_FBS,
                      name: "OZON",
                    }}
                    status={EnumUpdateRemaindStatus.SUCCESS}
                    haveError={false}
                    countProducts={0}
                  />
                </Grid>
              ))
            ) : items && items.length > 0 ? (
              items.map(
                ({
                  id,
                  marketplace,
                  dateTime,
                  status,
                  haveError,
                  countProducts,
                  type,
                   warehouse,
                }) => (
                  <Grid key={id} item xs={12}>
                    <LogItem
                      id={id}
                      dateTime={dateTime}
                      marketplace={marketplace}
                      status={status}
                      haveError={haveError}
                      countProducts={countProducts}
                      type={type}
                      warehouse={warehouse}
                    />
                  </Grid>
                )
              )
            ) : (
              <Grid item xs={12}>
                <Typography
                  textAlign={"center"}
                  variant={"subtitle1"}
                  fontSize={"1.3em"}
                >
                  {"Данные отсутствуют"}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <LogPagination />
        </Grid>
      </Grid>
    </Article>
  );
};

export default PageArticle;
